import _ from 'lodash';
import {
  loadUserById,
  getPasswordResetQuestions,
  resetAccountPassword,
  forceResetAccountPassword,
} from 'user/resources/user.api';
import resetAccountPasswordTemplate from './reset-account-password.html';

// eslint-disable-next-line no-undef
@Inject('$state', 'gettextCatalog', 'Notifications')
class ResetAccountPasswordController {
  constructor() {
    this.userId = this.$state.params.userId;
  }

  $onInit() {
    if (this.userId) {
      loadUserById(this.userId)
        .then((user) => {
          this.username = user.username;
          return getPasswordResetQuestions(this.username)
            .then((result) => {
              this.passwordResetQuestions = result.questions;
              this.questionsAndAnswers = {
                questions: _.clone(result.questions),
                answers: _.map(result.questions, () => ''),
              };
            });
        });
    } else {
      this.$state.go('user-manageUsers', { skipDirtyForms: true });
    }
  }

  forceSubmitForm() {
    forceResetAccountPassword(this.username)
      .then(() => this.Notifications.showAlert(
        this.gettextCatalog.getString('Success!'),
        this.gettextCatalog.getString('Force Password Reset Success!'),
      ).result)
      .then(() => this.cancelForm());
  }

  submitForm(form) {
    form.$setSubmitted();
    if (form.$invalid) {
      return;
    }
    const questionsAndAnswers = this.evalResetData();

    resetAccountPassword(this.username, questionsAndAnswers)
      .then(() => this.Notifications.showAlert(
        this.gettextCatalog.getString('Success!'),
        this.gettextCatalog.getString('Password Reset Success!'),
      ).result)
      .then(() => {
        form.$setPristine();
        return this.cancelForm();
      });
  }

  evalResetData() {
    const questionsAndAnswers = {
      questions: [],
      answers: [],
    };

    if (this.questionsAndAnswers.answers[0]) {
      questionsAndAnswers.questions.push(this.questionsAndAnswers.questions[0]);
      questionsAndAnswers.answers.push(this.questionsAndAnswers.answers[0]);
    }
    if (this.questionsAndAnswers.answers[1]) {
      questionsAndAnswers.questions.push(this.questionsAndAnswers.questions[1]);
      questionsAndAnswers.answers.push(this.questionsAndAnswers.answers[1]);
    }
    return questionsAndAnswers;
  }

  cancelForm() {
    this.$state.go('user-viewAccountDetails', { id: this.userId });
  }
}

export default class ResetAccountPasswordComponent {
  constructor() {
    this.template = resetAccountPasswordTemplate;
    this.controller = ResetAccountPasswordController;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/components/reset-account-password/components/reset-account-password/reset-account-password-component.js